import React, { useState } from "react";

const FaqSection = () => {
  const [activeFaq, setActiveFaq] = useState(0);

  const toggleFaq = (index) => {
    setActiveFaq((prev) => (prev === index ? null : index));
  };


  /* ================= LEFT COLUMN ================= */
  const faqsLeft = [
    {
      number: "1",
      question: "What are these conferences focused on?",
      answer:
        "Our conferences focus on the real-world application of artificial intelligence, data analytics, and digital transformation across global supply chains, energy systems, and enterprise operations.",
    },
    {
      number: "2",
      question: "Who should attend these events?",
      answer:
        "Senior executives, decision-makers, policymakers, technology leaders, investors, and professionals involved in supply chain management, energy transition, AI, and digital innovation.",
    },
    {
      number: "3",
      question: "Are the conferences virtual or in-person?",
      answer:
        "All current events are hosted as fully virtual conferences, allowing global participation without travel barriers while maintaining high-quality networking and engagement.",
    },
    {
      number: "4",
      question: "What type of content can attendees expect?",
      answer:
        "Attendees gain access to keynote presentations, expert panels, real-world case studies, and strategic discussions focused on practical insights rather than theoretical concepts.",
    },
  ];

  /* ================= RIGHT COLUMN ================= */
  const faqsRight = [
    {
      number: "5",
      question: "Can I participate as a speaker or sponsor?",
      answer:
        "Yes. We actively collaborate with industry leaders, solution providers, and organizations interested in speaking opportunities, sponsorships, and strategic partnerships.",
    },
    {
      number: "6",
      question: "How do I register for a conference?",
      answer:
        "Each conference has a dedicated website where you can find registration details, agendas, speaker information, and ticket options.",
    },
    {
      number: "7",
      question: "Will sessions be available on-demand?",
      answer:
        "Yes. Registered attendees typically receive access to session recordings after the event, allowing you to revisit key insights at your convenience.",
    },
    {
      number: "8",
      question: "How can my organization get involved?",
      answer:
        "Organizations can engage through sponsorship, speaking opportunities, partnerships, or by attending and contributing to discussions shaping the future of AI-driven industries.",
    },
  ];

  const renderFaqs = (faqs, offset) =>
    faqs.map((faq, index) => {
      const currentIndex = index + offset;
      const isActive = activeFaq === currentIndex;

      return (
        <li
          key={faq.number}
          className={`accordion block ${
            isActive ? "active-block" : ""
          }`}
        >
          <div
            className={`acc-btn ${isActive ? "active" : ""}`}
            onClick={() => toggleFaq(currentIndex)}
          >
            <span className="number">{faq.number}</span>
            {faq.question}
            <span className="arrow"></span>
          </div>

          <div
            className="acc_body"
            style={{
              maxHeight: isActive ? "1000px" : "0",
              overflow: "hidden",
              transition: "max-height 0.3s ease",
            }}
          >
            <div className="content">
              <p>{faq.answer}</p>
            </div>
          </div>
        </li>
      );
    });

  return (
    <section
      className="faq pt-150 pb-115"
      style={{ backgroundColor: "#f4f5fc" }}
    >
      <div className="container">
        <div className="da-sec-titlte text-center mb-30">
          <h2 className="title">Frequently Asked Questions</h2>
          <p style={{ marginTop: "10px", opacity: 0.85 }}>
            Everything you need to know before attending our conferences.
          </p>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <div className="da-left-faq">
              <div className="xb-faq xb-faq-two da-faq">
                <ul className="accordion_box clearfix list-unstyled">
                  {renderFaqs(faqsLeft, 0)}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="da-right-faq">
              <div className="xb-faq xb-faq-two da-faq">
                <ul className="accordion_box clearfix list-unstyled">
                  {renderFaqs(faqsRight, faqsLeft.length)}
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FaqSection;
